module.exports = __webpack_public_path__ + "static/media/logo_light.530e0091.svg";